(function (global) {
  'use strict';

  // Retail anchors for Stay Weird / Barcelony / Cut to Shape, including
  // integrated-sign supplier allowances. All upgrade amounts are list USD.
  const tiers = Object.freeze([
  {
    "areaM2": 0.04091598586640378,
    "amount": 169,
    "rgb": 35,
    "spectrum": 65,
    "widthCm": 40,
    "rows": 1
  },
  {
    "areaM2": 0.06086137631587378,
    "amount": 179,
    "rgb": 45,
    "spectrum": 85,
    "widthCm": 50,
    "rows": 1
  },
  {
    "areaM2": 0.06527994918856647,
    "amount": 209,
    "rgb": 50,
    "spectrum": 90,
    "widthCm": 52,
    "rows": 1
  },
  {
    "areaM2": 0.08457820174917927,
    "amount": 219,
    "rgb": 55,
    "spectrum": 105,
    "widthCm": 60,
    "rows": 1
  },
  {
    "areaM2": 0.09375169980388766,
    "amount": 279,
    "rgb": 60,
    "spectrum": 110,
    "widthCm": 63.5,
    "rows": 1
  },
  {
    "areaM2": 0.1310047697770725,
    "amount": 289,
    "rgb": 70,
    "spectrum": 125,
    "widthCm": 76.2,
    "rows": 1
  },
  {
    "areaM2": 0.17437223297339846,
    "amount": 299,
    "rgb": 80,
    "spectrum": 150,
    "widthCm": 88.9,
    "rows": 1
  },
  {
    "areaM2": 0.22392198542008196,
    "amount": 309,
    "rgb": 95,
    "spectrum": 170,
    "widthCm": 101.6,
    "rows": 1
  },
  {
    "areaM2": 0.2796279856740293,
    "amount": 339,
    "rgb": 105,
    "spectrum": 195,
    "widthCm": 114.3,
    "rows": 1
  },
  {
    "areaM2": 0.34122906287404464,
    "amount": 379,
    "rgb": 120,
    "spectrum": 215,
    "widthCm": 127,
    "rows": 1
  },
  {
    "areaM2": 0.41050655859344753,
    "amount": 419,
    "rgb": 135,
    "spectrum": 245,
    "widthCm": 140,
    "rows": 1
  },
  {
    "areaM2": 0.44125758141807875,
    "amount": 439,
    "rgb": 140,
    "spectrum": 250,
    "widthCm": 80,
    "rows": 2
  },
  {
    "areaM2": 0.5305373965952909,
    "amount": 479,
    "rgb": 160,
    "spectrum": 280,
    "widthCm": 160,
    "rows": 1
  },
  {
    "areaM2": 0.6878281134585359,
    "amount": 539,
    "rgb": 175,
    "spectrum": 310,
    "widthCm": 100,
    "rows": 2
  },
  {
    "areaM2": 0.9867222397807492,
    "amount": 679,
    "rgb": 210,
    "spectrum": 370,
    "widthCm": 120,
    "rows": 2
  },
  {
    "areaM2": 1.3408836524578318,
    "amount": 819,
    "rgb": 245,
    "spectrum": 435,
    "widthCm": 140,
    "rows": 2
  },
  {
    "areaM2": 1.439014921694987,
    "amount": 1049,
    "rgb": 255,
    "spectrum": 450,
    "widthCm": 145,
    "rows": 2
  },
  {
    "areaM2": 1.7483588551850306,
    "amount": 1139,
    "rgb": 280,
    "spectrum": 495,
    "widthCm": 160,
    "rows": 2
  }
].map(Object.freeze));
  const positive = value => typeof value === 'number' && Number.isFinite(value) && value > 0;
  const near = (a, b) => Math.abs(a - b) <= 1e-7 * Math.max(1, Math.abs(a), Math.abs(b));
  const cross = (a, b) => a[0] * b[1] - a[1] * b[0];
  const samePoint = (a, b) => near(a[0], b[0]) && near(a[1], b[1]);
  const invalid = reason => ({ valid: false, areaM2: null, amount: null, requiresQuote: true, reason, belowMinimum: false, currency: 'USD' });
  const cache = new Map();

  function tokenize(path) {
    if (typeof path !== 'string' || !path.trim() || path.length > 1000000) throw new Error('invalid-path');
    const tokens = [];
    const token = /[MLHVCSQTAZmlhvcsqtaz]|[-+]?(?:\d+\.?\d*|\.\d+)(?:[eE][-+]?\d+)?/y;
    let at = 0;
    while (at < path.length) {
      if (/[\s,]/.test(path[at])) { at++; continue; }
      token.lastIndex = at;
      const match = token.exec(path);
      if (!match) throw new Error('invalid-path');
      tokens.push(/^[a-z]$/i.test(match[0]) ? match[0] : Number(match[0]));
      if (tokens.length > 200000) throw new Error('invalid-path');
      at = token.lastIndex;
    }
    return tokens;
  }

  // Green's theorem integrates polynomial Beziers without flattening the path.
  function polynomialArea(xs, ys) {
    let twice = 0;
    for (let i = 0; i < xs.length; i++) {
      for (let j = 1; j < xs.length; j++) twice += (xs[i] * j * ys[j] - ys[i] * j * xs[j]) / (i + j);
    }
    return twice / 2;
  }
  function coefficients(points, dimension) {
    const v = points.map(point => point[dimension]);
    if (v.length === 3) return [v[0], 2 * (v[1] - v[0]), v[0] - 2 * v[1] + v[2]];
    return [v[0], 3 * (v[1] - v[0]), 3 * (v[0] - 2 * v[1] + v[2]), -v[0] + 3 * v[1] - 3 * v[2] + v[3]];
  }
  function arcSegment(start, end, rx, ry, degrees, large, sweep) {
    rx = Math.abs(rx); ry = Math.abs(ry);
    if (!rx || !ry || samePoint(start, end)) return null;
    const phi = degrees % 360 * Math.PI / 180, c = Math.cos(phi), s = Math.sin(phi);
    const dx = (start[0] - end[0]) / 2, dy = (start[1] - end[1]) / 2;
    const xp = c * dx + s * dy, yp = -s * dx + c * dy;
    let stretch = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (stretch > 1) { const scale = Math.sqrt(stretch); rx *= scale; ry *= scale; stretch = 1; }
    // Diameter endpoints suffer cancellation when a small hole is translated
    // far from the origin. Keep the exact half-circle at floating-point noise.
    const centerFactor = Math.abs(stretch - 1) < 1e-13 ? 0 : Math.max(0, (1 - stretch) / stretch);
    const factor = (large === sweep ? -1 : 1) * Math.sqrt(centerFactor);
    const cxp = factor * rx * yp / ry, cyp = -factor * ry * xp / rx;
    const center = [c * cxp - s * cyp + (start[0] + end[0]) / 2, s * cxp + c * cyp + (start[1] + end[1]) / 2];
    const u = [(xp - cxp) / rx, (yp - cyp) / ry], v = [(-xp - cxp) / rx, (-yp - cyp) / ry];
    let delta = Math.atan2(cross(u, v), u[0] * v[0] + u[1] * v[1]);
    if (!sweep && delta > 0) delta -= 2 * Math.PI;
    if (sweep && delta < 0) delta += 2 * Math.PI;
    if (![...center, rx, ry, delta].every(Number.isFinite)) throw new Error('invalid-path');
    return { center, rx, ry, delta };
  }

  function contoursFromPath(path) {
    const tokens = tokenize(path), contours = [];
    let at = 0, command = null, contour = null, current = [0, 0], last = '', cubicControl = null, quadraticControl = null;
    const number = () => {
      if (typeof tokens[at] !== 'number' || !Number.isFinite(tokens[at])) throw new Error('invalid-path');
      return tokens[at++];
    };
    const point = relative => { const p = [number(), number()]; return relative ? [current[0] + p[0], current[1] + p[1]] : p; };
    const local = p => [p[0] - contour.start[0], p[1] - contour.start[1]];
    const line = end => {
      contour.area += cross(local(current), local(end)) / 2;
      if (!samePoint(current, end)) contour.nonArc = true;
      current = end;
    };
    while (at < tokens.length) {
      if (typeof tokens[at] === 'string') command = tokens[at++];
      else if (!command) throw new Error('invalid-path');
      const op = command.toUpperCase(), relative = command !== op;
      if (op === 'M') {
        if (contour) throw new Error('unclosed-path');
        current = point(relative);
        contour = { start: current.slice(), area: 0, arcs: [], nonArc: false };
        command = relative ? 'l' : 'L';
      } else {
        if (!contour) throw new Error('invalid-path');
        if (op === 'Z') {
          line(contour.start.slice());
          if (!Number.isFinite(contour.area) || Math.abs(contour.area) <= 1e-12) throw new Error('degenerate-path');
          contours.push(contour); contour = null; command = null;
        } else if (op === 'L') line(point(relative));
        else if (op === 'H') { const x = number(); line([relative ? current[0] + x : x, current[1]]); }
        else if (op === 'V') { const y = number(); line([current[0], relative ? current[1] + y : y]); }
        else if (op === 'C' || op === 'S') {
          const first = op === 'C' ? point(relative) : (last === 'C' || last === 'S') ? [2 * current[0] - cubicControl[0], 2 * current[1] - cubicControl[1]] : current.slice();
          const second = point(relative), end = point(relative), points = [current, first, second, end].map(local);
          contour.area += polynomialArea(coefficients(points, 0), coefficients(points, 1));
          contour.nonArc = true; current = end; cubicControl = second;
        } else if (op === 'Q' || op === 'T') {
          const control = op === 'Q' ? point(relative) : (last === 'Q' || last === 'T') ? [2 * current[0] - quadraticControl[0], 2 * current[1] - quadraticControl[1]] : current.slice();
          const end = point(relative), points = [current, control, end].map(local);
          contour.area += polynomialArea(coefficients(points, 0), coefficients(points, 1));
          contour.nonArc = true; current = end; quadraticControl = control;
        } else if (op === 'A') {
          const rx = number(), ry = number(), rotation = number(), large = number(), sweep = number();
          if (![0, 1].includes(large) || ![0, 1].includes(sweep)) throw new Error('invalid-path');
          const end = point(relative), arc = arcSegment(current, end, rx, ry, rotation, large, sweep);
          if (arc) {
            const center = local(arc.center);
            contour.area += (arc.rx * arc.ry * arc.delta + center[0] * (end[1] - current[1]) - center[1] * (end[0] - current[0])) / 2;
            contour.arcs.push(arc); current = end;
          } else line(end);
        } else throw new Error('invalid-path');
      }
      last = op;
    }
    if (contour || !contours.length) throw new Error('unclosed-path');
    return contours;
  }

  function isMountingHole(contour, hole) {
    if (contour.nonArc || !contour.arcs.length) return false;
    return contour.arcs.every(arc => near(arc.center[0], hole.x) && near(arc.center[1], hole.y) && near(arc.rx, hole.r) && near(arc.ry, hole.r)) && near(Math.abs(contour.area), Math.PI * hole.r * hole.r);
  }

  function pathArea(boardPath, holes = []) {
    try {
      if (!Array.isArray(holes) || holes.some(hole => !hole || !Number.isFinite(hole.x) || !Number.isFinite(hole.y) || !positive(hole.r))) return { valid: false, reason: 'invalid-holes' };
      const key = boardPath + '\n' + JSON.stringify(holes);
      if (cache.has(key)) return cache.get(key);
      const contours = contoursFromPath(boardPath), used = new Set();
      let area = 0, outerContours = 0;
      for (const contour of contours) {
        const holeIndex = holes.findIndex((hole, i) => !used.has(i) && isMountingHole(contour, hole));
        if (holeIndex >= 0) used.add(holeIndex);
        else { area += Math.abs(contour.area); outerContours++; }
      }
      // Product geometry lists every mounting hole and appends it as an arc
      // subpath. Ignore those contours entirely; sum all separate board pieces.
      if (used.size !== holes.length || !positive(area)) return { valid: false, reason: 'invalid-hole-contours' };
      const result = Object.freeze({ valid: true, area, outerContours, ignoredHoles: used.size });
      if (cache.size >= 64) cache.delete(cache.keys().next().value);
      cache.set(key, result);
      return result;
    } catch (error) {
      return { valid: false, reason: error.message || 'invalid-path' };
    }
  }

  function measure(geometry, physicalWidthCm) {
    if (!geometry || !positive(geometry.width) || !positive(geometry.height) || !positive(physicalWidthCm)) return invalid('invalid-geometry');
    if (geometry.backing != null && geometry.backing !== 'shape') return invalid('cut-to-shape-required');
    const measured = pathArea(geometry.boardPath, geometry.holes || []);
    if (!measured.valid) return invalid(measured.reason);
    const areaM2 = measured.area * Math.pow(physicalWidthCm / geometry.width, 2) / 10000;
    if (!positive(areaM2)) return invalid('invalid-area');
    return { valid: true, areaM2, areaCm2: areaM2 * 10000, outlineArea: measured.area, outerContours: measured.outerContours, ignoredHoles: measured.ignoredHoles };
  }

  function priceForArea(areaM2) {
    if (!positive(areaM2)) return invalid('invalid-area');
    const first=tiers[0],last=tiers[tiers.length-1];
    const base={valid:true,areaM2,requiresQuote:false,reason:null,belowMinimum:areaM2<first.areaM2,currency:'USD'};
    if(areaM2<=first.areaM2) return {...base,amount:Math.round(149+(first.amount-149)*Math.sqrt(areaM2/first.areaM2))};
    // Beyond the largest calibrated area, keep a continuous estimate. Costs
    // outside the calibrated anchors still need a fresh supplier/freight check.
    if(areaM2>=last.areaM2) return {...base,amount:Math.round(last.amount+(areaM2-last.areaM2)*700)};
    const index=tiers.findIndex(tier=>areaM2<=tier.areaM2),low=tiers[index-1],high=tiers[index];
    return {...base,amount:Math.round(low.amount+(areaM2-low.areaM2)/(high.areaM2-low.areaM2)*(high.amount-low.amount))};
  }

  function upgradesForArea(areaM2) {
    if (!positive(areaM2)) return { rgb: null, spectrum: null };
    const first = tiers[0], last = tiers[tiers.length - 1];
    const exact = tiers.find(tier => Math.abs(tier.areaM2 - areaM2) <= 1e-12);
    if (exact) return { rgb: exact.rgb, spectrum: exact.spectrum };
    if (areaM2 < first.areaM2) return { rgb: first.rgb, spectrum: first.spectrum };
    const index = areaM2 > last.areaM2 ? tiers.length - 1 : tiers.findIndex(tier => areaM2 < tier.areaM2);
    const low = tiers[index - 1], high = tiers[index];
    const proportion = (areaM2 - low.areaM2) / (high.areaM2 - low.areaM2);
    // Separate supplier costs set the two upgrade curves. Extrapolation uses
    // the final segment; it is an estimate beyond the largest calibrated area.
    const ceilFive = amount => Math.ceil((amount - 1e-10) / 5) * 5;
    return {
      rgb: ceilFive(low.rgb + proportion * (high.rgb - low.rgb)),
      spectrum: ceilFive(low.spectrum + proportion * (high.spectrum - low.spectrum))
    };
  }

  function quote(geometry, physicalWidthCm) {
    const measured = measure(geometry, physicalWidthCm);
    return measured.valid ? { ...measured, ...priceForArea(measured.areaM2) } : measured;
  }

  global.SigntasyAreaPricing = Object.freeze({ version: 'integrated-loss-area-20261013-v1', tiers, pathArea, measure, priceForArea, upgradesForArea, quote });
})(typeof window === 'undefined' ? globalThis : window);
